import { render } from "./SubmitOTP.vue?vue&type=template&id=214c3302&scoped=true"
import script from "./SubmitOTP.vue?vue&type=script&lang=js"
export * from "./SubmitOTP.vue?vue&type=script&lang=js"

import "./SubmitOTP.vue?vue&type=style&index=0&id=214c3302&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-214c3302"]])

export default __exports__